import { render, staticRenderFns } from "./theme-divider.vue?vue&type=template&id=fbcbc396&"
import script from "./theme-divider.vue?vue&type=script&lang=js&"
export * from "./theme-divider.vue?vue&type=script&lang=js&"
import style0 from "./theme-divider.vue?vue&type=style&index=0&id=fbcbc396&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports